document.addEventListener('click', (e) => {
    const reserveButton = e.target.closest('.home .intro .actions button');
    if (!reserveButton) return;
    e.preventDefault();
    const nextSection = document.querySelector('.home .intro')?.nextElementSibling;
    if (!nextSection) return;
    const headerHeight = document.querySelector('header')?.offsetHeight ?? 0;
    const targetTop = nextSection.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
});

const header = document.querySelector('header');
if (header) {
    const updateHeader = () => {
        header.classList.toggle('at-top', window.scrollY <= 0);
    };
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
}

const parallaxTargets = [];
const details = document.querySelector('.home .details');
if (details) {
    parallaxTargets.push({ el: details, factor: 0.25 });
}
const events = document.querySelector('.home .events');
if (events) {
    parallaxTargets.push({ el: events, factor: 0.25 });
}
const paddocks = document.querySelector('.home .paddocks');
if (paddocks) {
    parallaxTargets.push({ el: paddocks, factor: 0.25 });
}
const links = document.querySelector('.home .links');
if (links) {
    parallaxTargets.push({ el: links, factor: 0.25 });
}

let parallaxScheduled = false;
const updateParallax = () => {
    parallaxScheduled = false;
    const viewportH = window.innerHeight;
    for (const { el, factor } of parallaxTargets) {
        const rect = el.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const offset = (center - viewportH / 2) * factor;
        el.style.setProperty('--parallax-y', `${-offset}px`);
    }
};
const scheduleParallax = () => {
    if (parallaxScheduled) return;
    parallaxScheduled = true;
    requestAnimationFrame(updateParallax);
};
if (parallaxTargets.length) {
    updateParallax();
    window.addEventListener('scroll', scheduleParallax, { passive: true });
    window.addEventListener('resize', scheduleParallax);
}

document.querySelectorAll(".details a[image]").forEach((element) => {
    element.classList.add("with-image");
    element.bkg = document.createElement("div");
    element.bkg.classList.add("background");
    element.bkg.style.backgroundImage = `url(${element.getAttribute("image")})`;
    element.removeAttribute("image");


    const legend = document.createElement("div");
    legend.classList.add("legend");
    legend.innerText = element.innerText;
    element.innerText = "";


    const capacity = element.getAttribute("capacity");
    if (!isNaN(capacity)) {
        const capacityElement = document.createElement("div");
        capacityElement.classList.add("capacity");
        capacityElement.innerText = `${capacity}`;
        element.bkg.append(capacityElement);
        element.removeAttribute("capacity");
    }


    element.bkg.append(legend);

    element.prepend(element.bkg);

    parallaxTargets.push({ el: element.bkg, factor: 0.18 });
});

if (parallaxTargets.length) {
    updateParallax();
}
